import React from "react";
import "./App.css";
import axios from 'axios';
import {
  Button,
  Card,
  Grid, Typography,
  Container,
  TextField, CircularProgress,
  MenuItem, FormControl, InputLabel, Select, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import debounce from "lodash.debounce";
import PopupNotification from './PopupNotification';
import { useEffect, useState, useCallback } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let globalOtps = [];
const accessToken = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3";
function OTPSMART() {

  const [ports, setPorts] = useState([]);
  const [sending, setSending] = useState([]);
  const [promo, setPromo] = useState([]);
  const [clickedPortSims, setClickedPortSims] = useState([]);
  const [numbers,] = useState({});
  const [isGreen, setIsGreen] = useState(false);
  const [defaultIp, setDefaultIp] = useState('10.147.19.101');
  const [ip, setIp] = useState(localStorage.getItem('ip') || defaultIp);
  const [showPopup, setShowPopup] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [notes, setNotes] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [addressForHandleActivate, setAddressForHandleActivate] = useState('');
  const [addressForHandleActivateG, setAddressForHandleActivateG] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [availablePcs, setAvailablePcs] = useState([]);

  useEffect(() => {
    const fetchData = async (goipNumber) => {
      try {
        const response = await fetch(`https://frek.cc/proxy/10.147.19.123:5090/fetch-api/goip${goipNumber}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const textData = await response.text();
  
        const regex = /^(?!\/\/).*var strLocNumList = '({.*?})';/ms;
        const matches = textData.match(regex);
        if (matches && matches[1]) {
          let jsonString = matches[1].replace(/\\"/g, '"');
          if (jsonString[0] !== '{' || jsonString[jsonString.length - 1] !== '}') {
            throw new Error('Extracted string is not valid JSON');
          }
  
          return JSON.parse(jsonString);
        } else {
          throw new Error('Data not found in the fetched string.');
        }
      } catch (error) {
        console.error('Error fetching or parsing data:', error);
        throw error;
      }
    };
  
    const processFetchData = async () => {
      try {
        let numbersForHandleActivateG = [];
        let numbersForHandleActivate = [];
  
        for (let i = 1; i <= 6; i++) {
          const jsonData = await fetchData(i);
  
          if (jsonData && jsonData.data) {
            if (i === 1) {
              // Add the 32nd element to numbersForHandleActivateG only if it's not empty
              if (jsonData.data.length >= 32 && jsonData.data[31][1]) {
                numbersForHandleActivateG.push(jsonData.data[31][1]);
              }
              // Add elements to numbersForHandleActivate, skipping empty ones
              numbersForHandleActivate.push(...jsonData.data.slice(0, 31).filter(item => item[1]).map(item => item[1]));
            } else {
              // Add elements to numbersForHandleActivate from other indices, skipping empty ones
              numbersForHandleActivate.push(...jsonData.data.filter(item => item[1]).map(item => item[1]));
            }
          }
        }
  
        // Log the numbersForHandleActivateG and numbersForHandleActivate
        console.log('numbersForHandleActivateG:', numbersForHandleActivateG);
        console.log('numbersForHandleActivate:', numbersForHandleActivate);
  
        setAddressForHandleActivateG(numbersForHandleActivateG.join(', '));
        setAddressForHandleActivate(numbersForHandleActivate.join(', '));
  
      } catch (error) {
        console.error('Error in processFetchData:', error);
      }
    };
  
    processFetchData();
  }, []);
  
  








  useEffect(() => {
    // Function to call on component mount
    getData();
    fetchNotes();
  }, []);



  useEffect(() => {
    document.title = `Testing`;
  }, []);



  useEffect(() => {
    fetch("https://frek.cc/proxy/38.54.86.24:5000/expiry/1000")
      .then((response) => response.json())
      .then((data) => {
        if (data[0] && data[0].value) {
          const pcValues = data[0].value.split(",").map(Number);
          setAvailablePcs(pcValues);

          if (!localStorage.getItem('ip')) {
            const defaultIpNumber = pcValues[0] + 100;
            const newDefaultIp = `10.147.19.${defaultIpNumber}`;
            setDefaultIp(newDefaultIp);
            setIp(newDefaultIp);
            localStorage.setItem('ip', newDefaultIp);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching PC numbers:", error);
        setIsLoading(false);
      });
  }, []);


  const handleChangeIp = (event) => {
    setIp(event.target.value);
    localStorage.setItem('ip', event.target.value);
    window.location.reload();
  }

  const getPcNumberFromIp = (ip) => {
    let parts = ip.split('.');
    let lastPart = Number(parts[parts.length - 1]);
    return lastPart - 100;
  };

  const generateIpOptions = () => {
    const ipOptions = [];

    for (let i = 100; i <= 123; i++) {
      const ipAddress = `10.147.19.${i}`;
      const pcNumber = i - 100;
      const pcName = `PC${pcNumber.toString().padStart(2, '0')}`; // Pad with zero for consistency

      // Check if PC number is in the available list, or is PC00 or PC23
      const isDisabled = pcNumber !== 0 && pcNumber !== 23 && !availablePcs.includes(pcNumber);

      ipOptions.push(
        <MenuItem value={ipAddress} key={ipAddress} disabled={isDisabled}>
          {pcName}
        </MenuItem>
      );
    }

    return ipOptions;
  };


  const [cardData, setCardData] = useState({
    asr: "0",
    todaySent: "0",
    todayFailed: "0",
  });

  async function getData() {
    try {
      const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/home/show`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": accessToken,
        },
        body: JSON.stringify({}),
      });

      const result = await response.json();
      const [, days, hours, minutes] = result.data.onlineDuration.match(/(\d+) Day (\d+) hours (\d+) minutes/) || [0, 0, 0, 0];

      const totalHours = (Number(days) * 24) + Number(hours);
      const totalDays = Math.floor(totalHours / 24);
      const remainingHours = totalHours % 24;

      let hourFormat;
      if (totalDays > 0) {
        hourFormat = `${totalDays} Day${totalDays > 1 ? 's' : ''}`;
      } else if (remainingHours > 0) {
        hourFormat = `${remainingHours} Hour${remainingHours > 1 ? 's' : ''}`;
      } else {
        hourFormat = `${minutes} Minute${minutes > 1 ? 's' : ''}`;
      }
      setCardData({
        asr: (parseInt(result.data.asr).toFixed(0)),
        hourFormat: hourFormat,
        registerStatus: result.data.registerStatus,
        username: result.data.username.substring(7, result.data.username.length - 3),
        todaySent: result.data.chargeCnt,
        todayFailed: result.data.todayFailed,
        ver: result.data.version,
      });
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch for getData was aborted');
      } else {
        console.error('Fetch error in getData:', error);
      }
    }
  }







  useEffect(() => {
    debouncedChangeHandler();
  });
  useEffect(() => {
    setSending(
      ports
        .filter((a) => a.status === 1)
        .sort((a, b) => {
          if (a.slotId > b.slotId) return 1;
          if (a.slotId < b.slotId) return -1;
          return 0;
        })
    );
  }, [ports]);
  const debouncedChangeHandler = useCallback(debounce(getPorts, 750), []);


  async function handleDisablePort(portName) {
    const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/port/setup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        ports: [parseInt(portName.replace("COM", ""))],
        type: 2,
      }),
    });
    handleNotification(`Port ${portName} Disabled Succesfully!`);
  }



  function getRandomAddress(addressStr) {
    const delimiters = [",", "\n"];
    let addresses = [];

    delimiters.forEach((delimiter) => {
      if (addressStr.includes(delimiter)) {
        addresses = [...addresses, ...addressStr.split(delimiter)];
      }
    });

    if (addresses.length === 0) {
      addresses = [addressStr]; // if there's only one address without delimiters
    }

    const randomIndex = Math.floor(Math.random() * addresses.length);
    return addresses[randomIndex].trim(); // remove any extra spaces if there are any
  }



  async function handleActivate(portName, address) {

    const portObject = ports.find(p => p.portName === `COM${portName}`);
    if (!portObject) {
      console.error("Port not found");
      return;
    }
    const chosenAddress = getRandomAddress(addressForHandleActivate);
    const slotId = portObject.slotId;

    const random5Digit = generateRandom5DigitNumber(); // Generate random 5-digit number
    const random5Letters = generateRandom5Letters();
    const random5Char = generateRandom5Characters();

    const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/send/sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        port: parseInt(portName),
        address: chosenAddress,  // Using the parameter here instead of a hardcoded value
        sms: `(03) ${random5Char}`, // Added Code section 
      }),
    });
  }

{/*sms: `(03) PC${getPcNumberFromIp(ip)} - COM${parseInt(portName)} - Slot${slotId} ${random5Char}`, // Added Code section*/}

  async function handleActivateG(portName, address) {

    const portObject = ports.find(p => p.portName === `COM${portName}`);
    if (!portObject) {
      console.error("Port not found");
      return;
    }
    const chosenAddress = getRandomAddress(addressForHandleActivateG);
    const slotId = portObject.slotId;

    const random5Digit = generateRandom5DigitNumber(); // Generate random 5-digit number
    const random5Letters = generateRandom5Letters();
    const random5Char = generateRandom5Characters();

    const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/send/sms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        port: parseInt(portName),
        address: chosenAddress,  // Using the parameter here instead of a hardcoded value
        sms: `(02) ${random5Char}`, // Added Code section
      }),
    });
  }

 {/* sms: `(02) PC${getPcNumberFromIp(ip)} - COM${parseInt(portName)} - Slot${slotId} ${random5Char}`, // Added Code section */}

  function generateRandom5DigitNumber() {
    return Math.floor(10000 + Math.random() * 90000);
  }

  function generateRandom5Letters() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }


  function generateRandom5Characters() {
    let result = '';
    const characters = 'BDFHJLNPRTVXZacegikmoqsuwy0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }




  const handleClickPortSim = (portSim) => {
    setClickedPortSims((prevClickedPortSims) => {
      if (prevClickedPortSims.includes(portSim)) {
        return prevClickedPortSims.filter((sim) => sim !== portSim);
      } else {
        return [...prevClickedPortSims, portSim];
      }
    });
  };







  const toggleGreenText = () => {
    setIsGreen(!isGreen);
  };


  const fetchNotes = async () => {
    const pcNumber = getPcNumberFromIp(ip) + 100; // Increment the result of getPcNumberFromIp by 100
    const url = `https://frek.cc/proxy/38.54.86.24:5000/expiry/${pcNumber}`; // Use the incremented PC number in the URL

    try {
      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        if (data && data.length > 0) {
          // Assuming the latest note is the first item in the response array
          const savedNotes = data[0].value;
          setNotes(savedNotes);
        }
      } else {
        console.error('Error retrieving notes!');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };


  async function handleAT(port) {
    const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/send/at`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        port: parseInt(port),
        command: "AT+QLEDMODE=6",
      }),
    });
    handleNotification(`PC${getPcNumberFromIp(ip)} Port ${port} LED now ON!`);

    const data = await response.json();
    return data.data;
  }




  async function getPorts() {
    const firstresult = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/port/query`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        bool: false,
        pageSize: 1,
        size: 10,
        ascs: [],
        descs: [],
      }),
    });
    const size = await firstresult.json();
    const response = await fetch(`https://frek.cc/proxy/38.54.86.24:5000/proxy/${getPcNumberFromIp(ip)}/port/query`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': accessToken
      },
      body: JSON.stringify({
        bool: false,
        pageSize: 1,
        size: size.data.sizeTotal,
        ascs: [],
        descs: [],
      }),
    });
    const result = await response.json();
    setPorts(result.data.data.filter((a) => a.status !== 3 && a.status !== 4 && a.network !== 0));
  }

  const handleNotification = (message) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };



  return ports, (
    <>

      <Container maxWidth="xxl">
        <Grid container spacing="5px" style={{ paddingTop: 0 }}>
          <Grid item xs={12} sm={12}>
            <PortList
              ports={ports}
              handleActivate={handleActivate}
              handleActivateG={handleActivateG}
              handleDisablePort={handleDisablePort}
              numbers={numbers}
              sending={sending}
              setShowModal={setShowModal}
              showModal={showModal}
              addressForHandleActivate={addressForHandleActivate}
              setAddressForHandleActivate={setAddressForHandleActivate}
              addressForHandleActivateG={addressForHandleActivateG}
              setAddressForHandleActivateG={setAddressForHandleActivateG}
              clickedPortSims={clickedPortSims}
              handleClickPortSim={handleClickPortSim}
              isGreen={isGreen}
              toggleGreenText={toggleGreenText}
              ip={ip}
              handleChangeIp={handleChangeIp}
              generateIpOptions={generateIpOptions}
              showPopup={showPopup}
              popupMessage={popupMessage}
              fadeOut={fadeOut}
              handleNotification={handleNotification}
              getPcNumberFromIp={getPcNumberFromIp}
              cardData={cardData}
              notes={notes}
              handleAT={handleAT}

            />
          </Grid>


        </Grid>
      </Container>
    </>
  );
}

function PortList({
  ports,
  handleActivate, handleDisablePort, showPopup, popupMessage, fadeOut, handleNotification,
  handleActivateG, setShowModal, showModal, addressForHandleActivate, setAddressForHandleActivate, addressForHandleActivateG, setAddressForHandleActivateG, handleSave, clickedPortSims,
  handleClickPortSim, ip, handleChangeIp, generateIpOptions, getPcNumberFromIp, cardData, notes, handleAT


}) {

  const [smsSenders, setSmsSenders] = useState([]);

  const [recentSmsData, setRecentSmsData] = useState([]);

  const isRecent = (dateString) => {
    const smsTime = new Date(dateString);
    const currentTime = new Date();
    const differenceInMilliseconds = currentTime - smsTime;
    const differenceInMinutes = differenceInMilliseconds / (60 * 1000);

    return differenceInMinutes <= 30;
  };

  async function fetchSmsData() {
    const response = await fetch("https://frek.cc/proxy/38.54.86.24:5005/get-sms");
    const smsData = await response.json();

    // Filter the SMS data for recent messages
    const recentSms = smsData.filter(sms => isRecent(sms.date));

    setRecentSmsData(recentSms);
  }

  function determineRowColor(portSim) {
    const relatedSms = recentSmsData.filter(sms => sms.sender === portSim);

    if (relatedSms.length === 0) return "#5555";

    const has02 = relatedSms.some(sms => sms.content.startsWith("(02)"));
    const has03 = relatedSms.some(sms => sms.content.startsWith("(03)"));

    if (has02 && has03) return "#7B68EE";
    if (has02) return "	#3CB371";
    if (has03) return "#BDB76B";

    return "#5555";  // default color
  }

  useEffect(() => {
    fetchSmsData(); // Fetch immediately upon mounting

    const intervalId = setInterval(() => {
      fetchSmsData(); // Fetch every 3 seconds
    }, 3000);

    return () => clearInterval(intervalId); // Clear the interval when the component unmounts
  }, []);



  // Calculate the counts for has02 and has03
  const has02Count = ports.filter(port => {
    const relatedSms = recentSmsData.filter(sms => sms.sender === port.sim);
    return relatedSms.some(sms => sms.content.startsWith("(02)"));
  }).length;

  const has03Count = ports.filter(port => {
    const relatedSms = recentSmsData.filter(sms => sms.sender === port.sim);
    return relatedSms.some(sms => sms.content.startsWith("(03)"));
  }).length;

  const bothCount = ports.filter(port => {
    const relatedSms = recentSmsData.filter(sms => sms.sender === port.sim);
    return relatedSms.some(sms => sms.content.startsWith("(02)")) &&
      relatedSms.some(sms => sms.content.startsWith("(03)"));
  }).length;


  function sleep(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }


  const [isCopied, setIsCopied] = useState(false);

  const handleCopyToClipboard = () => {
    const valuesToCopy = ports.map((port) => port.sim.substring(0) || "No Number");
    navigator.clipboard.writeText(valuesToCopy.join("\n"));
    setIsCopied(true);
  };

  const handleSimulateClicks = () => {
    ports.forEach((port) => {
      handleClickPortSim(port.portName);
    });
  };


  // Derive arrays of ports with messages starting with "(02)" and "(03)"
  const has02 = ports.filter(port => {
    const relatedSms = recentSmsData.filter(sms => sms.sender === port.sim);
    return relatedSms.some(sms => sms.content.startsWith("(02)"));
  });

  const has03 = ports.filter(port => {
    const relatedSms = recentSmsData.filter(sms => sms.sender === port.sim);
    return relatedSms.some(sms => sms.content.startsWith("(03)"));
  });

  // Assuming that has02 and has03 are arrays of objects that have an id property
  const portsMissing02 = ports.filter(port => !has02.some(hasPort => hasPort.id === port.id));
  const portsMissing03 = ports.filter(port => !has03.some(hasPort => hasPort.id === port.id));
  const portsMissingBoth = ports.filter(port =>
    !has02.some(hasPort => hasPort.id === port.id) &&
    !has03.some(hasPort => hasPort.id === port.id)
  );





  return (





    <Card>
<ToastContainer />

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '10px' }}>
        <FormControl variant="outlined">
          <InputLabel
            id="demo-simple-select-outlined-label"
            style={{ color: 'black', fontSize: '15px' }}
          >
            Select PC
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={ip}
            onChange={handleChangeIp}
            label="Select"
            sx={{
              color: 'black', // set font color
              width: '100px', // set width
              height: '30px', // set height
            }}
            style={{ fontSize: '15px' }}
          >
            {generateIpOptions()}
          </Select>
        </FormControl>
      </div>



      <Typography
        align="center"
        sx={{ fontSize: 14, fontWeight: 300 }}
      >
        Account: {cardData.username} | Register Status:                 {cardData.registerStatus === 1 ? "️Ok √" :
          cardData.registerStatus === 2 ? <CircularProgress size={7} color="primary" /> :
            "No X"} | On Duration: {cardData.hourFormat} | Group: {notes}
      </Typography>





      <Container style={{ paddingTop: 0, paddingBottom: 2, paddingLeft: 2, paddingRight: 2 }}
        maxWidth="xl"
        sx={{
          paddingTop: 0, paddingBottom: 1,
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={3} sm={2} md={10}>
            <Typography variant="subtitle1">Total: {ports.length}</Typography>
            <Typography variant="subtitle1">Lock: {ports.filter(port => port.network === 2).length}</Typography>
            <Typography variant="subtitle1">Off: {ports.filter(port => port.network === 0).length}</Typography>
            <Typography variant="subtitle1">Err: {ports.filter(port => port.network === -1).length}</Typography>
            <Typography variant="subtitle1">Status: {addressForHandleActivate.length > 0 ? 'Ready' : 'Wait...'}</Typography>
          </Grid>

          {/* Grid item for ports missing 02 */}
          <Grid item xs={3} sm={3} md={10}>
            <Paper elevation={3} style={{ padding: 1, textAlign: 'left' }}>
              <Typography variant="subtitle2">02</Typography>
              <Typography variant="subtitle2">OK: {has02Count} | X: {ports.length - has02Count}</Typography>
            </Paper>
          </Grid>




          {/* Grid item for ports missing 03 */}
          <Grid item xs={3} sm={3} md={10}>
            <Paper elevation={3} style={{ padding: 1, textAlign: 'left' }}>
              <Typography variant="subtitle2">03</Typography>
              <Typography variant="subtitle2">OK: {has03Count} | X: {ports.length - has03Count}</Typography>
            </Paper>
          </Grid>


          {/* Grid item for ports missing both 02 and 03 */}
          <Grid item xs={3} sm={3} md={10}>
            <Paper elevation={3} style={{ padding: 1, textAlign: 'left' }}>
              <Typography variant="subtitle2">Both</Typography>
              <Typography variant="subtitle2">OK: {bothCount} | X: {ports.length - bothCount}</Typography>

            </Paper>
          </Grid>


        </Grid>
        <TableContainer component={Paper} sx={{ backgroundColor: "#5555" }}>
          <Table aria-label="simple table" >
            <TableRow>
              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>Slot</TableCell>
              <Tooltip title="Click Here to Test all to Smart (51503)">
                <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                >
                  <Button variant="outlined" color="secondary" disabled={
                    parseInt(addressForHandleActivate.length) === 0
                  } onClick={async () => {
                    for (let i = 0; i < ports.length; i++) {
                      const p = ports[i];
                      const relatedSms = recentSmsData.filter(sms => sms.sender === p.sim);
                      const has03 = relatedSms.some(sms => sms.content.startsWith("(03)"));

                      if (!has03 && parseInt(p.signal) !== 0 && p.status !== 1) {
                        await handleActivate(p.portName.replace("COM", ""));
                        if (i !== ports.length - 1) {
                          await sleep(500);
                        }
                      }
                    }


                    handleNotification(`PC${getPcNumberFromIp(ip)} Testing all numbers  to Smart (51503) Done`);
                  }}>
                    T03
                  </Button>



                </TableCell>
              </Tooltip>


              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>Led</TableCell>
              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>Port</TableCell>



              <Tooltip title="Click Here to Test all to Globe (51502)">
                <TableCell sx={{ fontSize: 20, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                >
                  <Button variant="outlined" color="secondary" disabled={
                    parseInt(addressForHandleActivate.length) === 0
                  } onClick={async () => {
                    for (let i = 0; i < ports.length; i++) {
                      const p = ports[i];
                      const relatedSms = recentSmsData.filter(sms => sms.sender === p.sim);
                      const has02 = relatedSms.some(sms => sms.content.startsWith("(02)"));

                      if (!has02 && parseInt(p.signal) !== 0 && p.status !== 1) {
                        await handleActivateG(p.portName.replace("COM", ""));
                        if (i !== ports.length - 1) {
                          await sleep(500);
                        }
                      }
                    }
                    handleNotification(`PC${getPcNumberFromIp(ip)} Testing all numbers  to Globe (51502) Done`);
                  }}>
                    T02
                  </Button>

                </TableCell>
              </Tooltip>

              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 10, }}>Status</TableCell>
              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>Sent</TableCell>
              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>Disable</TableCell>
              <TableCell sx={{ fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>FS</TableCell>

            </TableRow>
            <TableBody>
              {ports
                .sort((a, b) => {
                  if (a.slotId > b.slotId) return 1;
                  if (a.slotId < b.slotId) return -1;
                  return 0;
                })
                .map((port) => (
                  <TableRow
                    key={port.portName}
                    sx={{ "&:last-child td, &:last-child th": {} }}
                    style={{
                      backgroundColor: determineRowColor(port.sim)
                    }}
                    onDoubleClick={() => handleClickPortSim(port.portName)}
                  >
                    <TableCell sx={{ fontSize: 20, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>{port.slotId}</TableCell>
                    <TableCell align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>
                      <Button sx={{ color: "#7fff00", fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                        disabled={
                          parseInt(port.status) === 1
                        }
                        onClick={() =>
                          handleActivate(port.portName.replace("COM", ""))
                        }
                      >
                        T03
                      </Button >

                    </TableCell>


                    <TableCell align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>
                      <Button sx={{ color: "#7fff00", fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                        onClick={() =>
                          handleAT(port.portName.replace("COM", ""))
                        }
                      >
                        On
                      </Button >

                    </TableCell>


                    <TableCell
                      sx={{ fontSize: 20, fontWeight: 50, color: isCopied ? "#0000FF" : "" }}
                      align="center"
                      style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}
                    >
                      {port.portName.substring(3)}
                    </TableCell>


                    <TableCell align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>
                      <Button sx={{ color: "#7fff00", fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}
                        disabled={
                          parseInt(port.status) === 1
                        }
                        onClick={() =>
                          handleActivateG(port.portName.replace("COM", ""))
                        }
                      >
                        T02
                      </Button >

                    </TableCell>
                    <TableCell align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}>
                      {port.network === 0 ? (
                        <div style={{ color: "#FF0000", fontSize: 20, fontWeight: 300 }}>Off</div>
                      ) : port.network === -1 ? (
                        <div style={{ color: "#FF0000", fontSize: 20, fontWeight: 300 }}>Err</div>
                      ) : port.status === 0 ? (
                        <div style={{ color: "", fontSize: 20, fontWeight: 300 }}>Idle</div>
                      ) : port.status === 1 ? (
                        <div style={{ color: "#0AF306", fontSize: 20, fontWeight: 300 }}>Snd</div>
                      ) : null}
                    </TableCell>

                    <TableCell sx={{ fontSize: 20, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>{port.chargeCnt}</TableCell>
                    <TableCell align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>
                      <Button sx={{ color: "red", fontSize: 15, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}

                        onClick={() =>
                          handleDisablePort(port.portName.replace("COM", ""))
                        }
                      >
                        Off
                      </Button >

                    </TableCell>
                    <TableCell sx={{ fontSize: 20, fontWeight: 50 }} align="center" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, }}>{port.successionFail}</TableCell>

                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Container>





    </Card>
  );
}

export default OTPSMART;